import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from "../imgs/Logo.png"

const MenuBar: React.FC = () => {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [eventsOpen, setEventsOpen] = useState(false);

  useEffect(() => {
    if (location.pathname === '/') {
      setIsScrolled(false); // Reset scroll effect on the homepage
      return;
    }

    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup listener on component unmount or route change
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);

  const getTextColor = () => {
    return location.pathname === '/' ? 'text-greentext' : 'text-greenbutton';
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-30 transition-all duration-300 ${
        isScrolled ? 'bg-tantext shadow-lg' : 'bg-transparent'
      } ${getTextColor()}`}
    >
      <div className="absolute top-0 left-0 mt-[-64px] ml-[-64px] flex items-center">
        <Link to="/" className='flex items-center'>
          <img
            src={Logo}
            alt="Motiv8 Logo"
            className="h-72 object-contain"
          />
          <span className="text-4xl font-bold -mt-8 -ml-16">
            Motiv8 Living
          </span>
        </Link>
      </div>

          <div className="py-7 sm:px-6 lg:px-8">
          <div className="flex items-center justify-end h-16 font-sans">
          <div className="hidden md:flex space-x-16 text-xl relative">
            <div
              className="relative"
              onMouseEnter={() => setServicesOpen(true)}
              onMouseLeave={() => setServicesOpen(false)}
            >
              <Link to="/services" className="cursor-pointer px-4 py-2 hover:opacity-80">
                Services
              </Link>
              {servicesOpen && (
                <div className="absolute left-1/2 transform -translate-x-1/2 mt-0 bg-tantext text-darkgreentext rounded shadow-lg w-64 border border-gray-300">
                  <ul className="flex flex-col items-center text-base">
                    <li className="hover:bg-lighttan w-full text-center p-2">
                      <Link to="/group-breathwork">Group Breathwork Classes - Online</Link>
                    </li>
                    <li className="hover:bg-lighttan w-full text-center p-2">
                      <Link to="/individual-instruction">Individual 1:1 Instruction</Link>
                    </li>
                    <li className="hover:bg-lighttan w-full text-center p-2">
                      <Link to="/wim-hof-workshop">Wim Hof Fundamentals Workshop</Link>
                    </li>
                    <li className="hover:bg-lighttan w-full text-center p-2">
                      <Link to="/community-breathwork">Community Breathwork</Link>
                    </li>
                    <li className="hover:bg-lighttan w-full text-center p-2">
                      <Link to="/cacao-and-sound-bath">Cacao Ceremony and Sound Bath Breathwork</Link>
                    </li>
                    <li className="hover:bg-lighttan w-full text-center p-2">
                      <Link to="/travel-retreats">Travel Retreats</Link>
                    </li>
                  </ul>
                </div>
              )}
            </div>

            {/* Events Dropdown */}
            <div
              className="relative"
              onMouseEnter={() => setEventsOpen(true)}
              onMouseLeave={() => setEventsOpen(false)}
            >
              <span className="cursor-pointer px-4 py-2 hover:opacity-80">Events</span>
              {eventsOpen && (
                <div className="absolute left-1/2 transform -translate-x-1/2 mt-0 bg-tantext text-darkgreentext rounded shadow-lg w-64 border border-gray-300">
                  <ul className="flex flex-col items-center text-base">
                    <li className="hover:bg-lighttan w-full text-center p-2">
                      <Link to="/private-events">Private Events</Link>
                    </li>
                    <li className="hover:bg-lighttan w-full text-center p-2">
                      <a href="https://calendly.com/seanmotiv8living" className="hover:opacity-80">
                        Upcoming Events
                      </a>
                    </li>
                  </ul>
                </div>
              )}
            </div>

            <Link to="/philosophy" className="hover:opacity-80">
              Philosophy
            </Link>
            <Link to="/about" className="hover:opacity-80">
              About
            </Link>
            <Link to="/contact" className="hover:opacity-80">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default MenuBar;
